/** How anything drawn over the editor stage says a press was its own, since it reports no pick. */

import { createContext, useContext } from "react";

/** Set by the stage frame for whatever it draws. The default no-op is what a bare overlay gets. */
export const StageClaim = createContext<() => void>(() => undefined);

/** Claim the click in flight, so the stage does not read it as a click on empty canvas. */
export function useStageClaim(): () => void {
  return useContext(StageClaim);
}
